var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcn120Record(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8480",
    "data-name": "Rectangle 8480",
    width: 120,
    height: 120,
    transform: "translate(876 352)",
    fill: "#cdcdcd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn_120_record",
    transform: "translate(-516 -428)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_687",
    "data-name": "Mask Group 687",
    transform: "translate(-360 76)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "undraw_Questions_re_1fy7",
    transform: "translate(876 369.716)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3603",
    "data-name": "Ellipse 3603",
    cx: 6.535,
    cy: 6.535,
    r: 6.535,
    transform: "translate(54.751 71.317)",
    fill: "#21aa95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37950",
    "data-name": "Path 37950",
    d: "M142.69,116.99c3.656-1.1,7.543-2.243,10.442-4.853,2.591-2.332,4.34-5.894,3.267-9.392s-4.28-5.819-7.592-6.976A31.148,31.148,0,0,0,143,94.462c-2.136-.311-4.281-.566-6.426-.811q-13.024-1.49-26.146-1.82c-4.317-.109-8.632-.106-12.95-.043-3.856.056-7.916.055-11.493-1.584A10.6,10.6,0,0,1,79.9,83.564c-.895-3.517.756-7.1,3.123-9.645a25.282,25.282,0,0,1,4.21-3.512c1.632-1.127,3.321-2.175,5.046-3.152a70.272,70.272,0,0,1,10.622-4.9c1.811-.658,3.648-1.226,5.5-1.75a47.075,47.075,0,0,0,4.648-1.489c2.924-1.165,5.706-3.14,6.449-6.376a9.963,9.963,0,0,0-2.566-8.676c-2.41-2.636-6.043-3.792-9.527-3.979A30.683,30.683,0,0,0,96,42.1c-3.921,1.325-7.757,2.848-11.76,3.921a79.124,79.124,0,0,1-12.1,2.25,32.832,32.832,0,0,1-6.074.29,7.345,7.345,0,0,1-4.608-1.83,4.557,4.557,0,0,1-1.483-3.926c.04-.27.45-.155.411.113a4.5,4.5,0,0,0,2.484,4.337,10.606,10.606,0,0,0,5.842.877,76.409,76.409,0,0,0,12.575-1.818,101.058,101.058,0,0,0,11.892-3.671,43.432,43.432,0,0,1,11.485-2.95,17.151,17.151,0,0,1,10.069,2.049,11.139,11.139,0,0,1,5.195,7.248,8.4,8.4,0,0,1-2.472,8c-2.319,2.138-5.5,3.051-8.461,3.893A77.518,77.518,0,0,0,98,64.82a69.021,69.021,0,0,0-10.342,5.815c-3.16,2.16-6.279,4.877-7.279,8.73a8.042,8.042,0,0,0,.4,5.394,9.856,9.856,0,0,0,3.163,3.753c3.171,2.333,7.168,2.812,11,2.86,4.3.054,8.6-.092,12.907-.021q13.155.216,26.257,1.6,3.283.347,6.557.768a59.3,59.3,0,0,1,5.864.951c3.433.8,6.773,2.329,8.906,5.239a8.285,8.285,0,0,1,.706,9.059c-1.638,3.224-4.707,5.274-7.966,6.621A56.527,56.527,0,0,1,142.8,117.4a.213.213,0,0,1-.113-.411Z",
    transform: "translate(-42.363 -32.97)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3604",
    "data-name": "Ellipse 3604",
    cx: 3.41,
    cy: 3.41,
    r: 3.41,
    transform: "translate(14.476 6.464)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3605",
    "data-name": "Ellipse 3605",
    cx: 3.41,
    cy: 3.41,
    r: 3.41,
    transform: "translate(38.13 12.928)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3606",
    "data-name": "Ellipse 3606",
    cx: 3.41,
    cy: 3.41,
    r: 3.41,
    transform: "translate(58.161)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3607",
    "data-name": "Ellipse 3607",
    cx: 3.41,
    cy: 3.41,
    r: 3.41,
    transform: "translate(70.663 14.491)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3608",
    "data-name": "Ellipse 3608",
    cx: 3.41,
    cy: 3.41,
    r: 3.41,
    transform: "translate(53.757 31.255)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3609",
    "data-name": "Ellipse 3609",
    cx: 3.41,
    cy: 3.41,
    r: 3.41,
    transform: "translate(32.305 39.352)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3610",
    "data-name": "Ellipse 3610",
    cx: 3.41,
    cy: 3.41,
    r: 3.41,
    transform: "translate(55.036 51.996)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3611",
    "data-name": "Ellipse 3611",
    cx: 3.41,
    cy: 3.41,
    r: 3.41,
    transform: "translate(79.471 59.1)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3612",
    "data-name": "Ellipse 3612",
    cx: 3.41,
    cy: 3.41,
    r: 3.41,
    transform: "translate(108.026 57.537)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37951",
    "data-name": "Path 37951",
    d: "M112.668,43.83A18.911,18.911,0,0,0,93.947,62.415c0,.094,0,.757,0,1.624a4.794,4.794,0,0,0,4.794,4.794h0a4.8,4.8,0,0,0,4.8-4.8c0-.591,0-1,0-1.024a9.092,9.092,0,1,1,14,7.654l0,0s-6.823,4.393-8.9,10.418h0a13.355,13.355,0,0,0-.55,3.8c0,.529.031,5.16.091,8.919a4.942,4.942,0,0,0,4.943,4.862h0a4.943,4.943,0,0,0,4.943-4.974c-.021-3.442-.032-7.45-.032-7.741,0-3.7,3.569-7.387,6.5-9.791a19.719,19.719,0,0,0,6.782-10.8,12.326,12.326,0,0,0,.355-2.676,18.859,18.859,0,0,0-19-18.859Z",
    transform: "translate(-52.081 -34.169)",
    fill: "#21aa95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37952",
    "data-name": "Path 37952",
    d: "M155.167,148.563H35.5a.169.169,0,1,1,0-.338H155.167a.169.169,0,0,1,0,.338Z",
    transform: "translate(-35.336 -63.997)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3613",
    "data-name": "Ellipse 3613",
    cx: 4.262,
    cy: 4.262,
    r: 4.262,
    transform: "translate(85.02 30.26)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37953",
    "data-name": "Path 37953",
    d: "M112.94,113.094H111.2l-.829-6.718h2.571Z",
    transform: "translate(-31.534 -30.393)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37954",
    "data-name": "Path 37954",
    d: "M108.942,115.085H112.3V117.2h-5.474a2.115,2.115,0,0,1,2.115-2.115Z",
    transform: "translate(-30.522 -32.881)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37955",
    "data-name": "Path 37955",
    d: "M131.835,113.094h-1.742l-.829-6.718h2.571Z",
    transform: "translate(-36.933 -30.393)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37956",
    "data-name": "Path 37956",
    d: "M127.837,115.085H131.2V117.2h-5.474A2.115,2.115,0,0,1,127.837,115.085Z",
    transform: "translate(-35.921 -32.881)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3614",
    "data-name": "Ellipse 3614",
    cx: 3.489,
    cy: 3.489,
    r: 3.489,
    transform: "translate(85.145 31.83)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37957",
    "data-name": "Path 37957",
    d: "M157.344,96.413l1.561-3.587a4.458,4.458,0,0,0-.987-5.058,4.526,4.526,0,0,0-.436-.379,4.395,4.395,0,0,0-2.7-.933,4.572,4.572,0,0,0-1.9.423c-.051.023-.1.047-.152.071-.1.047-.195.1-.288.151a4.5,4.5,0,0,0-2.23,3.393l-.689,5.774c-.173.453-6.356,16.819-4.194,29.314a.635.635,0,0,0,.543.521l2.192.3a.639.639,0,0,0,.712-.5l3.678-17.532a.5.5,0,0,1,.966-.033l5.2,18.437a.635.635,0,0,0,.612.466.728.728,0,0,0,.124-.011l2.678-.516a.635.635,0,0,0,.516-.683C162.151,121.639,160.059,99.657,157.344,96.413Z",
    transform: "translate(-66.631 -46.348)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37958",
    "data-name": "Path 37958",
    d: "M140.435,83.306A1.429,1.429,0,0,0,141.94,84.9l1.95,4.687,1.475-2.187-2.078-4.116a1.436,1.436,0,0,0-2.853.024Z",
    transform: "translate(-65.361 -45.083)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37959",
    "data-name": "Path 37959",
    d: "M158.506,104.7a1.429,1.429,0,0,0,1.2-1.835l4.1-2.989-2.471-.925-3.518,2.98a1.436,1.436,0,0,0,.688,2.768Z",
    transform: "translate(-70.065 -49.92)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37960",
    "data-name": "Path 37960",
    d: "M147.769,94.185a2.423,2.423,0,0,1-.469-.046,2.316,2.316,0,0,1-1.7-1.366l-2.733-3.332a.639.639,0,0,1,.158-.949l1.944-1.2a.639.639,0,0,1,.883.212l1.926,3.173,3.688-2.726a1.381,1.381,0,0,1,1.607,2.211L149.4,93.516A2.309,2.309,0,0,1,147.769,94.185Z",
    transform: "translate(-66.019 -46.559)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37961",
    "data-name": "Path 37961",
    d: "M162.792,99.613h-.015a.64.64,0,0,1-.47-.223l-1.728-2.016a.639.639,0,0,1,.131-.948l3.236-2.158-2.932-3.525a1.381,1.381,0,0,1,2.115-1.731l3.564,3.482a2.348,2.348,0,0,1-.522,3.827l-2.913,3.09a.64.64,0,0,1-.465.2Z",
    transform: "translate(-71.075 -46.976)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37962",
    "data-name": "Path 37962",
    d: "M157.409,91.414a.658.658,0,0,1-.083-.005.634.634,0,0,1-.527-.436l-1.3-3.982a.438.438,0,0,1,.226-.529l.042-.02.115-.053a4.628,4.628,0,0,1,1.933-.429,4.451,4.451,0,0,1,2.438.733.445.445,0,0,1,.128.61l-2.436,3.817a.633.633,0,0,1-.537.3Z",
    transform: "translate(-69.662 -46.206)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3615",
    "data-name": "Ellipse 3615",
    cx: 1.395,
    cy: 1.395,
    r: 1.395,
    transform: "translate(91.247 29.83)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37963",
    "data-name": "Path 37963",
    d: "M156.863,71.873h0a3.694,3.694,0,0,0-3.694,3.694v1.563h1.922l.919-1.563.276,1.563h5.833l-1.563-1.563a3.694,3.694,0,0,0-3.694-3.694Z",
    transform: "translate(-69.003 -42.182)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37964",
    "data-name": "Path 37964",
    d: "M166.038,72.083a2.152,2.152,0,0,1,2.341-1.477,2.983,2.983,0,0,1,2.01,1.661,16.359,16.359,0,0,1,.893,2.547,4.613,4.613,0,0,0,1.391,2.271,2.07,2.07,0,0,0,2.5.134,2.858,2.858,0,0,1-5.324,1.02,6.183,6.183,0,0,1-.573-2.167,4.735,4.735,0,0,0-.691-2.123,1.756,1.756,0,0,0-1.961-.73Z",
    transform: "translate(-72.679 -41.814)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37965",
    "data-name": "Path 37965",
    d: "M100.065,69.689h0A4.794,4.794,0,0,1,95.271,64.9c0-.868,0-1.531,0-1.625a18.683,18.683,0,0,1,2.182-8.511,18.725,18.725,0,0,0-3.6,10.784c0,.094,0,.757,0,1.624a4.794,4.794,0,0,0,4.794,4.794h0a4.8,4.8,0,0,0,4.615-3.494A4.777,4.777,0,0,1,100.065,69.689Z",
    transform: "translate(-52.054 -37.292)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37966",
    "data-name": "Path 37966",
    d: "M117.67,57.06a9.093,9.093,0,0,1,7.907,12.7,9.092,9.092,0,1,0-15.262-9.516,9.074,9.074,0,0,1,7.354-3.186Z",
    transform: "translate(-56.759 -37.297)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37967",
    "data-name": "Path 37967",
    d: "M120.095,109.673h0a4.942,4.942,0,0,1-4.942-4.863c-.06-3.757-.091-8.388-.091-8.917a13.355,13.355,0,0,1,.55-3.8h0a13.5,13.5,0,0,1,.781-1.8,15.635,15.635,0,0,0-2.2,4.077h0a13.355,13.355,0,0,0-.55,3.8c0,.529.031,5.16.091,8.919a4.942,4.942,0,0,0,4.942,4.862h0a4.944,4.944,0,0,0,4.745-3.558A4.924,4.924,0,0,1,120.095,109.673Z",
    transform: "translate(-57.709 -47.442)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37968",
    "data-name": "Path 37968",
    d: "M25.168,113.185H26.91l.829-6.718H25.168Z",
    transform: "translate(-7.191 -30.419)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37969",
    "data-name": "Path 37969",
    d: "M0,0H5.474V2.115H2.115A2.115,2.115,0,0,1,0,0Z",
    transform: "translate(23.077 84.383) rotate(179.997)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37970",
    "data-name": "Path 37970",
    d: "M16.417,113.185h1.742l.829-6.718H16.416Z",
    transform: "translate(-4.69 -30.419)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37971",
    "data-name": "Path 37971",
    d: "M0,0H5.474V2.115H2.115A2.115,2.115,0,0,1,0,0Z",
    transform: "translate(16.827 84.383) rotate(179.997)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37972",
    "data-name": "Path 37972",
    d: "M52.951,133.962l-1.7-.089a.664.664,0,0,1-.628-.706l2.033-22.513,9.364,2.527.9-.246L60.1,132.864a.667.667,0,0,1-.619.56l-1.834.085a.664.664,0,0,1-.7-.681l.332-11.961a.221.221,0,0,0-.438-.051l-3.2,12.617a.66.66,0,0,1-.649.529Z",
    transform: "translate(-39.703 -53.262)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3616",
    "data-name": "Ellipse 3616",
    cx: 3.489,
    cy: 3.489,
    r: 3.489,
    transform: "translate(14.801 31.993)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37973",
    "data-name": "Path 37973",
    d: "M52.806,92.121l.384,8.278.139,3.012a.66.66,0,0,0,.437.593l9,3.259a.636.636,0,0,0,.227.04.66.66,0,0,0,.663-.68l-.369-14.884a5.247,5.247,0,0,0-4.368-5.068c-.087-.013-.176-.027-.264-.038a5.15,5.15,0,0,0-4.143,1.341,5.29,5.29,0,0,0-1.7,4.148Z",
    transform: "translate(-40.326 -46.387)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37974",
    "data-name": "Path 37974",
    d: "M71.24,110.665a1.43,1.43,0,0,1-.763-2.163l-3.051-4.057,2.633-.163,2.494,3.878a1.436,1.436,0,0,1-1.313,2.506Z",
    transform: "translate(-44.505 -51.441)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37975",
    "data-name": "Path 37975",
    d: "M67.724,103.656a.66.66,0,0,1-.361-.358l-4.6-10.953a1.771,1.771,0,1,1,3.265-1.371l4.6,10.953a.665.665,0,0,1-.355.869l-2.041.857a.659.659,0,0,1-.508,0Z",
    transform: "translate(-43.133 -47.329)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37976",
    "data-name": "Path 37976",
    d: "M59.34,105.091l4.415-8.454a.693.693,0,0,1,.934-.293L71.1,99.691a.693.693,0,0,1,.293.934l-4.415,8.454a.693.693,0,0,1-.934.293l-6.409-3.347a.693.693,0,0,1-.293-.934Z",
    transform: "translate(-42.172 -49.151)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37977",
    "data-name": "Path 37977",
    d: "M60.94,101.838a1.43,1.43,0,0,0-2.2-.634L54.5,98.4l-.007,2.638,4.018,2.261a1.436,1.436,0,0,0,2.424-1.459Z",
    transform: "translate(-40.811 -49.76)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37978",
    "data-name": "Path 37978",
    d: "M53.98,99.551l-3.457-2.739a2.438,2.438,0,0,1-1.111-3.855l3.139-4.114A1.434,1.434,0,0,1,54.984,90.3L52.5,94.367l3.65,1.731a.664.664,0,0,1,.277.955l-1.473,2.332a.665.665,0,0,1-.45.3l-.011,0A.667.667,0,0,1,53.98,99.551Z",
    transform: "translate(-39.2 -46.88)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37979",
    "data-name": "Path 37979",
    d: "M56.564,80.351a.3.3,0,0,1,.264-.4.7.7,0,0,1,.494.244,1.965,1.965,0,0,0,.436.375.375.375,0,0,0,.494-.089.687.687,0,0,0-.026-.533,5.243,5.243,0,0,1-.232-1.388,2.444,2.444,0,0,1,.349-1.484,1.964,1.964,0,0,1,1.683-.715,11.31,11.31,0,0,1,1.89.335.635.635,0,0,0,.618-.1.8.8,0,0,0,.032-.711,4.937,4.937,0,0,0-.748-1.783,2.685,2.685,0,0,0-1.713-.965,4.111,4.111,0,0,0-1.913.217,5.128,5.128,0,0,0-2.512,1.75,4.153,4.153,0,0,0-.792,3.069,3.789,3.789,0,0,0,1.4,2.394Z",
    transform: "translate(-40.911 -42.532)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37980",
    "data-name": "Path 37980",
    d: "M117.078,142.154A6.534,6.534,0,0,1,114.653,132a6.535,6.535,0,1,0,8.889,9.442,6.531,6.531,0,0,1-6.464.714Z",
    transform: "translate(-57.232 -59.36)",
    fill: "#3f3d56"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcn120Record);
export default __webpack_public_path__ + "static/media/icn_120_record.3a3337f5c36c6a1e6a1ece5d0fd3ae29.svg";
export { ForwardRef as ReactComponent };